import { Grid, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { colors } from "../../../common/Theme/Colors";
import {
  StyledCard,
  StyledTypography,
} from "../../../common/Utils/StyledComponents";
import { showToast } from "../../../common/Utils/ToastMessage";
import {
  useCriticalTaskMutation,
  useLazyGetReportedByPAListQuery,
  usePinTaskMutation,
} from "../../../request/Task";
import Translate from "../../../translation/utils/translateFunction";
import ListView from "../../ListView";
import { MarkCriticalAndPinTask } from "../Components/utils";
import { SUBTASK_PREFIX } from "../constants";
import { getReportedByPATaskColumns } from "./column.data";

const ReportedByPA = ({ fixNavbar }) => {
  const { isRtl } = useSelector((state) => state.formanagement);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [lastPageNo, setLastPageNo] = useState(0);
  const [reportedByPAList, setReportedByPAList] = useState([]);

  const [
    getReportedByPAlistApi,
    {
      data: reportedByPAData,
      isLoading: isLoadingReportedByPA,
      isError: isErrorReportedByPA,
      error: errorReportedByPA,
      isFetching: isFetchingReportedByPAList,
    },
  ] = useLazyGetReportedByPAListQuery();

  const [pinTask, { data: pinTaskData }] = usePinTaskMutation({
    fixedCacheKey: "pinnedTask",
  });

  const [markCritical, { data: markCriticalData }] = useCriticalTaskMutation({
    fixedCacheKey: "criticalTask",
  });

  useEffect(() => {
    setIsLoading(true);
    getReportedByPAlistApi(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pinTaskData, markCriticalData]);

  useEffect(() => {
    if (reportedByPAData?.nodes) {
      const { pageInfo, nodes } = reportedByPAData;
      setReportedByPAList(nodes);
      setLastPageNo(pageInfo.lastPageNo);
      setIsLoading(false);
    }
    if (errorReportedByPA && isErrorReportedByPA) {
      showToast({
        type: "error",
        message: JSON.stringify(errorReportedByPA),
      });
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportedByPAData, errorReportedByPA]);

  const CustomActionCellRender = (params) => {
    const { taskNumber } = params?.row;
    const isSubtask = taskNumber?.startsWith(SUBTASK_PREFIX);
    return (
      <div className="headerMargin">
        <a
          href="/#"
          className="nav-link dropdown-toggle"
          data-toggle="dropdown"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i className="fa fa-ellipsis-v manageIconColor" />
        </a>
        <div className="dropdown-menu dropdownAlignment dropdownIconMenu">
          <MarkCriticalAndPinTask
            taskId={params?.row?.taskId || params?.row?._id}
            isPinnedEnabled={params?.row?.isPinnedEnabled}
            isMarkCriticalEnabled={params?.row?.isMarkAsCriticalEnabled}
            hasFlagged={params?.row?.hasFlagged}
            hasPinned={params?.row?.hasPinned}
            markAsCritical={markCritical}
            pinTask={pinTask}
          />
          <div
            className="manageIconColor ml-3 cursor-pointer dropdown-item"
            onClick={() =>
              navigate(isSubtask ? "/subtask/view" : "/taskDetails", {
                state: {
                  taskId: params?.row?._id,
                  isTaskFilter: true,
                  navigateFrom: "/reportedByPA",
                },
              })
            }
          >
            <span className="manageIconColor fa fa-eye" />
            {Translate("manageTask:viewTask")}
          </div>
        </div>
      </div>
    );
  };

  const CustomSrCellRender = (params) => {
    return (
      <StyledTypography component="span" sx={{ color: colors.primary_009 }}>
        {params?.api?.getRowIndexRelativeToVisibleRows(params?.row?._id) +
          1 +
          (currentPage - 1) * 10}
      </StyledTypography>
    );
  };
  return (
    <Grid
      item
      xs={12}
      className={`section-body ${isRtl ? "rtlMargin" : "ltrMargin"} ${
        fixNavbar ? "marginTop" : ""
      } `}
    >
      <StyledCard variant="outlined">
        <div className="container-fluid p-4">
          <div className="tab-content">
            <div>
              <div className="card">
                <div className="card-header card-header-spacing formTitle">
                  <Stack flexDirection={"row"} alignItems={"center"}>
                    <i
                      className="icon fe fe-arrow-left mr-3 icon-size backnavigation-iconColor cursor-pointer"
                      onClick={() => navigate("/manageTask")}
                      title={Translate("common:backToolTip")}
                    />
                    <h5 className="page-title">
                      {Translate("manageTask:reportedByPA")}
                    </h5>
                  </Stack>
                </div>
                <div className="card-body">
                  <ListView
                    columns={getReportedByPATaskColumns(
                      CustomSrCellRender,
                      CustomActionCellRender
                    )}
                    rows={reportedByPAList}
                    autoHeight
                    sortingMode="server"
                    onPaginationChange={setCurrentPage}
                    currentPage={currentPage}
                    showShimmer={isFetchingReportedByPAList}
                    showLoader={isLoading || isLoadingReportedByPA}
                    totalPageCount={lastPageNo}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </StyledCard>
    </Grid>
  );
};
export default ReportedByPA;
